import { PermissionOperation } from 'generated/graphql';

export const isAuthorizedOperation = (
  actualOperation: PermissionOperation | undefined,
  requestedOperation: PermissionOperation,
): boolean => {
  switch (actualOperation) {
    case PermissionOperation.Write:
      return true;
    case PermissionOperation.Read:
      return requestedOperation === PermissionOperation.Read;
    case PermissionOperation.Invalid:
      return false;
    default:
      return false;
  }
};
